
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cursive",
      function () {
        return require("private-next-pages/cursive/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cursive"])
      });
    }
  